"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeyboardShortcutsOption_1 = require("./KeyboardShortcutsOption");
exports.KeyboardShortcutsOption = KeyboardShortcutsOption_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-shortcut-option/lib/index.js
// module id = 4969
// module chunks = 2